/**
 * @description 货币转换
 * @param {string} currency
 * @returns {string} 转换后的货币
 */
export default function transformCurrency(currency) {
    if (typeof currency !== 'string')
        return '';
    return currency === 'CNY' ? '￥' : currency;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/transformCurrency.js
// module id = null
// module chunks = 